import React, { Component, Fragment } from 'react'

const getWebmVideo = () =>
  import(/* webpackChunkName: "webmVideo" */ '../media/video/rudolf_mobile.webm')
    .then(url => url.default)
    .catch(error => `An error occurred while loading the component - ${error}`)

const getMp4Video = () =>
  import(/* webpackChunkName: "mp4Video" */ '../media/video/zlobek_movie.mp4')
    .then(url => url.default)
    .catch(error => `An error occurred while loading the component - ${error}`)

export default class Video extends Component {
  constructor(props) {
    super(props)
    this.state = {
      load: false,
      rudolfWebmMobile: null,
      rudolfWebmMp4: null,
    }
  }

  async componentDidMount() {
    const webmVideoUrl = await getWebmVideo()
    const mp4VideoUrl = await getMp4Video()

    await this.setStateAsync({
      rudolfWebmMobile: webmVideoUrl,
      rudolfWebmMp4: mp4VideoUrl,
    })
    this.setState({ load: true })
  }

  setStateAsync(state) {
    return new Promise(resolve => this.setState(state, resolve))
  }

  render() {
    const { rudolfWebmMobile, rudolfWebmMp4, load } = this.state

    return (
      <Fragment>
        {load && (
          <video autoPlay muted loop zindex="true" className="main_video mb20">
            <source src={rudolfWebmMobile} type="video/webm" />
            <source src={rudolfWebmMp4} type="video/mp4" />
            <track kind="captions" />
          </video>
        )}
      </Fragment>
    )
  }
}
